const en_US = {
  Name: 'Name',
  'First name': 'First name',
  'Receiver email': 'Receiver email',
  'Sender email': 'Sender email',
  Object: 'Object',
  Content: 'Content',
  Hello: 'Hello ',
  "let's go": "let's go",
  Email: 'Email',
  Password: 'Password',
  'My next actions': 'My next actions',
  House: 'House',
  'Period of stay': 'Period of stay',
  Profil: 'Profile',
  'My profile': 'My profile',
  'Need help ?': 'Need help ?',
  Settings: 'Settings',
  'Sign out': 'Sign out',
  'Privacy Policy': 'Privacy Policy',
  'Legal Notice': 'Legal Notice',
  'Centers of interest': 'Centers of interest',
  Notifications: 'Notifications',
  'Receive push notifications': 'Allow notifications',
  'Receive email notifications': 'Receive email notifications',
  'Receive push mobile notifications': 'Receive push mobile notifications',
  'Profile privacy': 'Profile privacy',
  'Level of confidentiality': 'Level of confidentiality',
  'Confidentiality CIUP': 'CIUP',
  'Confidentiality House': 'My house',
  'Confidentiality Private': 'Private',
  'Confidentiality CIUP description':
    'By selecting "CIUP", all members of the portal can see your profile (within the limits of the elements you wish to share)',
  'Confidentiality House description':
    'By selecting "House", only members of your house can see your profile (within the limits of the elements you wish to share)',
  'Confidentiality Private description':
    'By selecting "Private", no member of the CIUP will be able to access your profile',
  'Show my profile picture': 'Show my profile picture',
  'Show my phone number': 'Show my phone number',
  'Show my email address': 'Show my email address',
  'Show my house': 'Show my house',
  'Show my name': 'Show my name',
  'Application language': 'Application language',
  French: 'French',
  English: 'English',
  'All news': 'All news',
  News: 'News',
  'All events': 'All events',
  Events: 'Events',
  'of the house': 'of the house',
  Services: 'Services',
  About: 'About',
  'Contact House': 'Contact the house',
  'House Services': 'Services and procedures',
  'Update my profile picture': 'Update my profile picture',
  Cancel: 'Cancel',
  'From Photos': 'From Photos',
  'Take Picture': 'Take Picture',
  'Please allow access to the camera in the app settings on your phone':
    'Please allow access to the camera in the app settings on your phone',
  'Please allow access to the photo library in the app settings on your phone':
    'Please allow access to the photo library in the app settings on your phone',
  'Phone number': 'Phone number',
  Mail: 'Mail',
  '404 error': '404 error',
  'Page not found': 'Page not found',
  'Sorry find': 'Sorry, we couldn’t find the page you’re looking for.',
  'Go back home': 'Go back home',
  'Edit those informations': 'Edit those informations',
  '[Residents Portal] Request to update my email address':
    '[residents Portal] Request to update my email address',
  'Go back': 'Go back',
  Pages: 'Pages',
  'See my profile': 'See my profile',
  'The Residents Portal team will help you by email : ':
    'The residents Portal team will help you by email : ',
  Logout: 'Logout',
  'Information saved successfully': 'Information saved successfully',
  'See the news': 'See the news',
  'Coming Soon': 'Coming Soon !',
  Citescope: 'See the event on citescope',
  'See more': 'See more',
  'Enter phone number': 'Enter phone number',
  'Not loded yet': 'Not loded yet',
  Place: 'Place :',
  To: 'to',
  'Event Place': 'Event place',
  'Event Places': 'Event places',
  'Useful infos': 'Useful infos',
  Directory: 'My directory',
  'Mobile notifs are blocked':
    'Notifications are blocked. Please allow notification to be sent in your device settings!',
  'Web notifs are blocked':
    'Notifications are blocked. Please allow notification to be sent in your browser settings!',
  Loading: 'Loading...',
  Block: 'Block',
  Unblock: 'Unblock',
  preventionBlock: 'Are you sure you want to block this user?',
  preventionUnblock:
    'Are you sure you want to unblock this user? (he will have access to your contact information again)',
  'Contact request': ' contact request',
  'Contact requests': ' contact requests',
  'Contact request mobile': 'CONTACT REQUEST',
  'Contact requests mobile': 'CONTACT REQUESTS',
  'Contact request title': 'Contact request',
  'No new contact request': 'You have no new connection request',
  'Friend Request Action Success #request': 'Request successfully sent',
  'Friend Request Action Success #delete': 'Request deleted',
  'Friend Request Action Success #refuse': 'Request declined',
  'Friend Request Action Success #accept': 'Request accepted!',
  'Friend Request Action Failed': 'Something went wrong, please try later...',
  'Friend Request Action Label #request': 'Add',
  'Friend Request Action Label #delete': 'Delete',
  'Friend Request Action Label #prompt': 'Respond',
  'Friend Request Action Label #accept': 'Accept',
  'Friend Request Action Label #refuse': 'Decline',
  'Form Submited': 'Your request has been sent to the relevant department',
  'Form Not Submited':
    'Your request could not be transmitted, please try again',
  'Form unknown error': 'You can no longer participate in this form',
  'Form well submitted': 'Form successfully submitted - thank you.',
  FAQ: 'FAQ',
  'Enter the object': 'Enter the object',
  'Enter your request here': 'Enter your request here',
  Map: 'Map',
  'Search #all': 'All',
  'Search #news': 'News',
  'Search #events': 'Events',
  'Search #services': 'Services',
  'Search #users': 'Directory',
  'Search #places': 'Places',
  'Search in library': 'Search in library',
  Search: 'Search',
  'Search Reset': 'Reset',
  'See All Results': 'See all results',
  'No Results': 'No results in this category',
  'Search More': 'More',
  Searching: 'Searching...',
  'My checklists': 'My checklists',
  'Todo Checklists': 'My TODO list',
  'Done Checklists': 'My completed checklists',
  'No checklist': 'No checklist at this time',
  'Error loading entries': 'Error loading entries',
  'The checklist ends in': 'The checklist ends in',
  day: 'day',
  default: ' ',
  'assimile-resident': 'Assimilated Resident',
  'assimile-salarie': 'Assimilated Employee',
  resident: 'Resident',
  employee: 'Employee',
  other: 'Other',
  api: 'Api',
  Identification: 'Identification',
  'Identification card': 'Identification card',
  'QR code Identification': 'QR code Identification',
  'QR code identification': 'QR code identification',
  'Sports QR code': 'Sports QR code',
  'QR code sports offer': 'QR code sports offer',
  'Show your resident card in case of control, and scan one QR codes to access the facilities.':
    'Show your resident card in case of control, and scan one QR codes to access the facilities.',
  'No interests': 'No interests found',
  'Unavailable Datas': 'Unavailable Datas',
  Filter: 'Filter',
  hello: 'Hello',
  'Config profile': 'We will help you set up your profile.',
  'Start with language':
    'To begin, please choose the language you wish to use.',
  'Profile picture': 'Profile picture',
  'Profile picture info':
    'In order to identify yourself on campus, please take a photo of yourself. This photo will be displayed on your dematerialized resident card.',
  'Get started !': 'Get started !',
  Next: 'Next',
  "Let's go !": "Let's go !",
  'My curriculum': 'My curriculum',
  'My curriculum description':
    'In order to strengthen your resident profile, could you add the various information related to your course.',
  Formation: 'Formation',
  'Formation Placeholder': 'Search your formation',
  Discipline: 'Discipline',
  'Discipline Placeholder': 'Search your discipline',
  'Study Year': 'Study Year',
  'Study Year Placeholder': 'Search your study year',
  Establishment: 'Establishment',
  'Establishment Placeholder': 'Search your study establishment',
  'Notif description':
    'Notifications allow you to receive important information from the campus (closure of the park, incidents, ...), from your house (leaks, electrical problems, ...) and to be informed of the cultural news of the Cité',
  'Notif question': 'Would you like to receive notifications, to be informed ?',
  'Directory description': 'A directory is present on this application',
  'Directory question': 'How would you like to appear there ?',
  Interests: 'Interests',
  'Interests description':
    'In order to offer you cultural events that could interest you, could you select at least <b>3 themes</b> that interest you ?',
  Done: 'Setup done',
  'Done description':
    'From now on, take advantage of your resident card, campus <b>news and events</b>, access to services (<b>sport, library, health, catering, ...</b>), your <b>home space, the directory</b>, etc. Much more !',
  'My house committee': 'My house committee',
  'See all': 'See all',
  'See results': 'See results',
  'Reset filters': 'Reset filters',
  'No picture': 'No picture for profile selected, please take a picture.',
  'No cursus':
    'Not all curiculum information has been selected. Please complete all fields.',
  'Failed save data': 'Save data for user failed, please try again.',
  'Too few interests':
    'Too little interest selected. Please select at least 3.',
  Reset: 'Reset',
  'Current house': 'Current house',
  'Emergency Contacts': 'Emergency contacts',
  'No emergency number': 'No emergency number found',
  'Phone numbers': 'Phone numbers',
  'Email addresses': 'Adresses mail',
  Access: 'Access',
  Reception: 'Reception',
  'No places available': 'No places available',
  'Add filter': 'Add filter',
  'Apply filters': 'Apply filters',
  'Select all': 'Select all',
  Itinerary: 'Itinerary',
  'No user filtered': 'No users match the filters',
  'See main invoice': 'See main invoice',
  Invoices: 'Invoices',
  Invoice: 'Invoice',
  'No invoice': 'No invoice',
  'Additional parts': 'Additional parts',
  'File does not exist.': 'File does not exist.',
  'Digital services': 'Digital services',
  'Campus services': 'Campus servcies',
  'See the invoice': 'See the invoice',
};

export default en_US;
